import { render } from "./AllCoursesCategoriesPage.vue?vue&type=template&id=a815a29e&scoped=true"
import script from "./AllCoursesCategoriesPage.vue?vue&type=script&lang=js"
export * from "./AllCoursesCategoriesPage.vue?vue&type=script&lang=js"

import "./AllCoursesCategoriesPage.vue?vue&type=style&index=0&id=a815a29e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a815a29e"]])

export default __exports__